import {
  HumanReadableTextFormatterInterface,
  HumanReadableTextFormatterLang,
} from './human-readable-text-formatter.impl';

export type HumanReadableDateFormatterDayFormat = 'short' | 'long' | 'abbreviated';

export interface HumanReadableDateFormatterProps {
  date: Date | string;
  day_format?: HumanReadableDateFormatterDayFormat;
  lang?: keyof typeof HumanReadableTextFormatterLang;
}

export class HumanReadableDateFormatter extends HumanReadableTextFormatterInterface<
  HumanReadableDateFormatterProps,
  string
> {
  private static readonly WEEK_UNIT = {
    EN: {
      short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      abbreviated: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    },
    KR: {
      short: ['일', '월', '화', '수', '목', '금', '토'],
      long: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
      abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
    },
    JP: {
      short: ['日', '月', '火', '水', '木', '金', '土'],
      long: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
      abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
    },
  };

  protected toKR() {
    const { date, day_format = 'short' } = this.props;
    const index = new Date(date).getDay();
    return HumanReadableDateFormatter.WEEK_UNIT.KR[day_format][index] as string;
  }

  protected toEN() {
    const { date, day_format = 'short' } = this.props;
    const index = new Date(date).getDay();
    return HumanReadableDateFormatter.WEEK_UNIT.EN[day_format][index] as string;
  }

  protected toJP() {
    const { date, day_format = 'short' } = this.props;
    const index = new Date(date).getDay();
    return HumanReadableDateFormatter.WEEK_UNIT.JP[day_format][index] as string;
  }
}

export const formatter = {
  humanize: (props: HumanReadableDateFormatterProps) => new HumanReadableDateFormatter(props).humanize(),
};
